export default __webpack_public_path__ + "static/media/bg-min.9276c250.jpg";